// src/pages/About/Certificate.jsx
import React from 'react';
import Header from '../../components/common/Header/Header';
import Footer from '../../components/common/Footer/Footer';
import Layout from '../../components/common/Layout/Layout';
import certificate1 from '../../assets/images/certificate1.jpg';
import certificate2 from '../../assets/images/certificate2.jpeg';

const Certificate = () => {
    return (
        <>
            <style>{`
                .certificate-image {
                    width: 100%;
                    max-width: 800px;
                    height: auto;
                    border-radius: 12px;
                    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                
                .certificate-image:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
                }
                
                .certificate-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 3rem;
                    padding: 3rem 2rem;
                    max-width: 1200px;
                    margin: 0 auto;
                }
                
                @media (max-width: 768px) {
                    .certificate-container {
                        padding: 2rem 1rem;
                        gap: 2rem;
                    }
                }
            `}</style>

            <div style={{
                minHeight: '100vh',
                backgroundColor: '#ffffff',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
            }}>
                {/* Header */}
                <Header />

                {/* Certificate Header Section */}
                <section style={{
                    background: '#1a2332',
                    backgroundImage: `
                        radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 1px, transparent 1px),
                        radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 1px, transparent 1px)
                    `,
                    backgroundSize: '20px 20px, 30px 30px',
                    padding: '2rem 0',
                    marginBottom: '0',
                    position: 'relative',
                    overflow: 'hidden',
                    borderBottom: '1px solid rgba(255,255,255,0.1)'
                }}>
                    <div style={{
                        maxWidth: '1400px',
                        margin: '0 auto',
                        padding: '0 2rem',
                        position: 'relative',
                        zIndex: 2
                    }}>
                        <h1 style={{
                            fontSize: '2rem',
                            fontWeight: '600',
                            color: '#ffffff',
                            margin: '0',
                            textAlign: 'center',
                            textShadow: '0 1px 2px rgba(0,0,0,0.1)'
                        }}>
                            CERTIFICATES
                        </h1>
                    </div>
                </section>

                {/* Certificate Images Section */}
                <section style={{
                    backgroundColor: '#f8fafc',
                    minHeight: '70vh'
                }}>
                    <div className="certificate-container">
                        <img 
                            src={certificate1} 
                            alt="Certificate 1" 
                            className="certificate-image"
                        />
                        <img 
                            src={certificate2} 
                            alt="Certificate 2" 
                            className="certificate-image"
                        />
                    </div>
                </section>

                {/* Layout */}
                <Layout />

                {/* Footer */}
                <Footer />
            </div>
        </>
    );
};

export default Certificate;